import { Alert, FormField, GridContent, Heading, Label, Paragraph } from '@zillow/constellation';

import { TimeZoneDropdownOptions } from '../../../../constants/TourCalendar';

import type { TimeZoneIds } from '../../../../constants/TourCalendar';
import TimeZoneDropdownSelect from '../../../TimeZoneDropdownSelect';
import type { ComboboxOptionObjectInterface, ComboboxOptionType } from '@zillow/constellation-10';

type TourCalendarTimeZoneProps = {
  onTimeZoneSelection: (timeZone: TimeZoneIds) => void;
  timeZone?: TimeZoneIds;
  titleTag?: keyof JSX.IntrinsicElements;
  disableTimeZoneSelection: boolean;
};

const TourCalendarTimeZone = ({
  onTimeZoneSelection,
  timeZone,
  titleTag,
  disableTimeZoneSelection,
}: TourCalendarTimeZoneProps) => {
  const handleOptionSelect = (option: ComboboxOptionType) => {
    const timeZoneId = TimeZoneDropdownOptions.find(
      (timeZoneOption) => timeZoneOption.value === (option as ComboboxOptionObjectInterface).value,
    )?.value;

    if (timeZoneId) {
      onTimeZoneSelection(timeZoneId);
    }
  };

  const gridColumnStart = { default: '2', md: '4' };
  const gridColumnEnd = { default: 'span 22', md: 'span 10' };

  return (
    <>
      <GridContent
        gridColumnStart={gridColumnStart}
        gridColumnEnd={gridColumnEnd}
        marginTop={{ md: 'xs' }}
        padding={0}
        data-testid="TourCalendarTimeZone-Body"
      >
        <Heading level={4} as={titleTag ?? 'h4'} fontFamily="serif" marginBottom="xs">
          Select the property time zone
        </Heading>
        <Paragraph fontColor="textMedium" marginBottom={{ default: 'md', md: 5 }}>
          This helps ensure that your tour availability matches what’s provided to interested renters.
        </Paragraph>
      </GridContent>
      <GridContent gridColumnStart={gridColumnStart} gridColumnEnd={gridColumnEnd} padding={0}>
        <FormField
          label={<Label size="lg">Property time zone</Label>}
          control={
            <TimeZoneDropdownSelect
              timeZone={timeZone}
              handleOptionSelect={handleOptionSelect}
              disableTimeZoneSelection={disableTimeZoneSelection}
            />
          }
        />
      </GridContent>
      <GridContent marginTop="md" gridColumnStart={gridColumnStart} gridColumnEnd={gridColumnEnd} padding={0}>
        <Alert
          data-testid="TourCalendarTimeZone-Alert"
          appearance="warning"
          body="The time zone cannot be edited after continuing to the next page. Check that it's correct before proceeding."
        />
      </GridContent>
    </>
  );
};

export default TourCalendarTimeZone;
